import { qualityPresets } from '../config';
import type { QualityId } from '../types';

type FfmpegArgsOptions = {
  frameName: string;
  inputName: string;
  outputName: string;
  quality: QualityId;
  title: string;
};

export function buildFfmpegArgs({ frameName, inputName, outputName, quality: qualityId, title }: FfmpegArgsOptions) {
  const quality = qualityPresets[qualityId];
  const fps = String(quality.fps);
  return [
    '-loop',
    '1',
    '-progress',
    'pipe:1',
    '-framerate',
    fps,
    '-i',
    frameName,
    '-i',
    inputName,
    '-map',
    '0:v:0',
    '-map',
    '1:a:0',
    '-c:v',
    'libx264',
    '-preset',
    'veryfast',
    '-tune',
    'stillimage',
    '-crf',
    String(quality.crf),
    '-r',
    fps,
    '-g',
    fps,
    '-keyint_min',
    fps,
    '-sc_threshold',
    '0',
    '-pix_fmt',
    'yuv420p',
    '-c:a',
    'aac',
    '-b:a',
    `${quality.audioKbps}k`,
    '-shortest',
    '-movflags',
    '+faststart',
    '-metadata',
    `title=${title || 'Audio title video'}`,
    outputName,
  ];
}
